import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast";
import { statusUpdateProduct } from "services/apiProduct";

const useDisableProduct = () => {
    
    const queryClient = useQueryClient();

    const{isPending:isDisabling, isSuccess:isDisabled, mutate: disableProduct} = useMutation({
        mutationFn: statusUpdateProduct,
        onSuccess:(data)=>{
            queryClient.setQueryData(['productStatus'],data)
            queryClient.invalidateQueries({queryKey:['productList']})
            toast.success("Status updated")
        },
        onError:(error)=>{
            console.log("Error occurred while updating the status of product")
            if(error?.data && typeof error.data === 'object'){
                for (const key in error.data){
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg)
                }
            }else{
                toast.error(error.message || "Something went wrong")
            }
        }
    })

    return {isDisabling,isDisabled,disableProduct}
}

export default useDisableProduct
